import { rule } from '../core';
import { spaceValue, sizeValue, boolValue } from '../values';
export var spaceRule = function spaceRule(name) {
  return rule(name, spaceValue(sizeValue()));
};
export var directionRule = function directionRule(cssProp) {
  return rule(cssProp, sizeValue(boolValue(0, 'auto')));
};
export var sizeRule = function sizeRule(cssProp, trueVal, falseVal) {
  if (trueVal === void 0) {
    trueVal = '100%';
  }

  if (falseVal === void 0) {
    falseVal = 0;
  }

  return rule(cssProp, sizeValue(boolValue(trueVal, falseVal)));
};